<template>
    <main>
        <div class="card mb-2" :id="udid">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ link_list.title }}</h3>
                <div class="dashlet-action">
                    <span class="dashlet-refresh" @click="reFreshData()"><i class="fa-solid fa-refresh"></i></span>
                    <span class="dashlet-closed" @click="updateStatus(udid,0)"><i class="fa-solid fa-xmark"></i></span>
                </div>
            </div>
            <div class="card-body" v-if="link_list.customDashlet === undefined || link_list.customDashlet === false">
                <template v-if="customLoading=='openchart'">
                    <loader></loader>
                </template>
                <router-link to="/modules/applications" v-else>
                    <apexchart type="donut" width="100%" :options="chartOptions" :series="series">
                    </apexchart>
                </router-link>
            </div>
            <div v-else :id="udid">
                <component :is="dynamicComponent" ref="childComponentRef"></component>
            </div>
            <div class="card-footer text-end">
                <!--<router-link :to="link_list.routePath" class="btn btn-secondary btn-sm">View More
                </router-link>!-->
            </div>
        </div>
    </main>
</template>
<script>
    import { ref } from "vue";
    import loader from "@/views/shared/loading/Loading.vue";

    export default {
        name: 'genericDashletChart',
        props: {
            folder: {
                type: String,
                required: true
            },
            module: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            udid: {
                type: String,
                required: true
            },
            updateWidgetsList: '',
        },
        watch: {
            '$props': {
                handler: function (val) {
                    this.loadDashlet();
                },
                deep: true
            }
        },
        components: {
            loader,
        },
        data() {
            return {
                customLoading: false,
                loading: false,
                dynamicComponent: null,
                dataList: {},
                link_list: {
                    routePath: '',
                    customDashlet: false,
                },
                series: [],
                chartOptions: {
                    dataLabels: {
                        enabled: false,
                    },
                    labels: [],
                    legend: {
                        show: true,
                        position: 'top'
                    },
                },

            }
        },
        async mounted() {
            await this.loadDashlet();
        },
        methods: {
            async loadDashlet() {
                const self = this;
                const modules = this.module;
                const folder = this.folder;
                const title = this.title;
                console.log(folder);
                let searchaArray = require(`@/views/modules/${modules}/dashlets/${folder}/Chart.js`);
                self.link_list = searchaArray.default.link_list;
                if (typeof title !== 'undefined' && title !== '') {
                    self.link_list.title = title;
                }

                if (self.link_list.customDashlet === undefined || self.link_list.customDashlet === false) {
                    axios.get('api/modules/' + self.link_list.routePath + '/' + self.link_list.actionName,
                        {
                            params: {
                                page: self.link_list.page,
                                sort: self.link_list.sort,
                                search: self.link_list.search,
                                perPage: self.link_list.perPage
                            }
                        }).then(function (response) {
                            const dataList = response.data.chartData;
                            self.chartOptions = {
                                dataLabels: {
                                    enabled: false
                                },
                                labels: dataList.categories_data
                            };
                            self.series = dataList.series_data;
                            self.loading = false;
                        }).catch(function (error) {
                            console.log('error');
                        })
                } else {
                    this.dynamicComponent = (await import(`@/views/modules/${modules}/dashlets/${folder}/custom/${self.link_list.customDashlet}.vue`)).default;
                }
            },
            updateStatus(id, status) {
                const self = this;
                $('#' + id).remove();
                self.customLoading = 'savewidgets';
                axios.post('api/widgets/updatewidgetsstatus', { id: id, status: status }).then(function (response) {
                    self.customLoading = false;
                    var res = response.data;
                    self.updateWidgetsList();
                })
            },
            reFreshData() {
                const self = this;
                if (self.link_list.customDashlet === undefined || self.link_list.customDashlet === false) {
                    self.loadDashlet();
                }else{
                    self.$refs.childComponentRef.customLoadDashlet();
                }
            }
        },


    }
</script>